import { atom, selector } from "recoil";
import {
  getEffectivePermissions,
  getPermissionNames,
  ISessionPermission,
} from "@/utils/session-permissions";
import { linesOfBusinessState } from "./lines-of-business";

export type { ISessionPermission } from "@/utils/session-permissions";

/** Full session permissions: every permission with all the lines that grant it. */
export const permissionsState = atom<ISessionPermission[]>({
  key: "permissionsState",
  default: [],
});

/**
 * Permissions that apply to the lines currently selected in the header. Use this
 * for show/hide/allow checks; use `permissionsState` only when you need every line
 * the user may act in (e.g. choosing lines when adding an employee).
 */
export const effectivePermissionsState = selector<ISessionPermission[]>({
  key: "effectivePermissionsState",
  get: ({ get }) =>
    getEffectivePermissions(get(permissionsState), get(linesOfBusinessState)),
});

/** Derived list of effective permission names, for code that only needs names. */
export const permissionNamesState = selector<string[]>({
  key: "permissionNamesState",
  get: ({ get }) => getPermissionNames(get(effectivePermissionsState)),
});
